import React, { useState } from 'react';
import Modal from '../Modal/Modal';
import ConfirmAndCancel from '../Buttons/ConfirmAndCancel';
import Moment from 'react-moment';
import FormDropdown from '../FormField/FormDropdown';
import { onlineClassCancelReasons, inPersonClassCancelReasons } from '../../Components-Pages/Bookings2/Helper'
import Auth from "../../Auth/Auth";

function CancelBookingPopup({
  show,
  onClose,
  // submitResponse,
  onConfirm,
  booking,
  inst,
  campus,
  level,
}) {
  let role = Auth.verifyUserRole();
  let [cancelReason, setCancelReason] = useState('');
  let [showCancelButton, setShowCancelButton] = useState('');
  const { booking_date, end_booking_date, start_time } = booking;


  // Calculates number of hours until class starting time

  const bookingDateTime = `${booking_date} ${start_time}`;
  const diffInMilliSeconds =
    Date.parse(bookingDateTime) - Date.parse(new Date());
  const hoursUntilClass = diffInMilliSeconds / (1000 * 60 * 60);

  const callUs = <a href='tel:1800732398'>Call us at 1800 READYT</a>;

  let cancelPopupMessage, popupMessageOnTop;

  if (hoursUntilClass < 0) {
    popupMessageOnTop = null;
    cancelPopupMessage = (
      <>
        <strong>
          It's not possible to cancel bookings that passed their starting time.
        </strong>
      </>
    );
  } else if (hoursUntilClass < 2) {
    popupMessageOnTop = null;
    cancelPopupMessage = (
      <>
        <strong>
          Cancelling a booking within 2 hours of commencement is not allowed, as
          it will likely result in the class being unattended. If you are
          experiencing an emergency or unavoidable late arrival, please phone
          our office.
        </strong>
        <br />
        {callUs}
      </>
    );
  } else if (hoursUntilClass < 5) {
    popupMessageOnTop = null;
    cancelPopupMessage = (
      <strong>
        You are attempting to cancel this booking within 5 hours of
        commencement. Cancelling now may result in the class being unattended if
        a replacement teacher cannot be booked. This may impact the customer's
        willingness to engage you for future bookings. Do you wish to proceed
        with cancelling this booking?
      </strong>
    );
  } else {
    popupMessageOnTop = (
      <div>
        <strong>{'Are you sure you want to cancel this job?'}</strong>
        <br />
        <br />
      </div>
    );
    cancelPopupMessage = null;
  }



  const cancelReasonOptions = (booking.online
    ? onlineClassCancelReasons
    : inPersonClassCancelReasons
  ).map((reason) => {
    return (
      <option value={reason.value} key={reason.value}>
        {reason.description}
      </option>
    );
  });

  const cancelReasonOptionHandler = (e) => {
    const allowCancelReason = (booking.online
      ? onlineClassCancelReasons
      : inPersonClassCancelReasons
    ).find((reason) => {
      return reason.value == e.target.value;
    });
    setShowCancelButton(allowCancelReason ? allowCancelReason.allowCancel : '');
    setCancelReason(e.target.value);
  };

  return (
    <Modal
      show={show}
      onClose={onClose}
      header='Cancel Booking'
      className='delete-modal'
    >
      <p className='center-text my-3'>
        {popupMessageOnTop}
        <strong>{inst.institution_name}</strong>
        <br />
        <span>
          <Moment format='DD MMM YYYY'>{booking.dates?.[0]?.date || booking_date}</Moment>
          {end_booking_date && end_booking_date !== (booking.dates?.[0]?.date || booking_date) && (
            <>
              {' - '}
              <Moment format='DD MMM YYYY'>{end_booking_date}</Moment>
            </>
          )}
        </span>
        <br />
        <span>
          {level} @ {campus.campus_shortname}
        </span>
      </p>
      <br />

      {cancelPopupMessage}

      {hoursUntilClass < 2 || (
        <>
          <FormDropdown onChange={cancelReasonOptionHandler}>
            <option value=''>Select a cancellation reason</option>
            {cancelReasonOptions}
          </FormDropdown>

          {showCancelButton || role === 'admin' ? (
            <ConfirmAndCancel
              onCancel={onClose}
              cancelText='Go Back'
              onConfirm={() => {
                onConfirm(cancelReason);
                onClose();
              }}
              confirmText='Cancel Booking'
            />
          ) : (
            showCancelButton === '' || (
              <>
                <br />
                <a href='tel:1800732398'>Call us at 1800 READYT</a>
              </>
            )
          )}
        </>
      )}
    </Modal>
  );
}

export default CancelBookingPopup;
